import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import planView from '../views/planView.vue'
import Pages from '../views/pages.vue'
import DocsView from '../views/DocsView.vue'

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/plan/:id', name: 'plan', component: planView },
  { path: '/terms', component: Pages },
  { path: '/docs', name: 'docs', component: DocsView },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  }
})

// keep the canonical of the page in step with the route on in-app navigation (chat #2697)
router.afterEach((to) => {
  const link = document.getElementById('canonical')
  if (!link) return
  const path = to.path.replace(/\/+$/, '') || '/'
  link.href = 'https://www.wizzo.stream' + (path === '/' ? '/' : path)
})

export default router
